import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { TrainsInfo } from "@core/models/trainsInfo";
import {
  TrainService,
} from "@core/services";
import { TranslateService } from "@ngx-translate/core";
import * as _lodash from "lodash-es";
import "moment/min/locales.min";
import { UserService } from '../../../core/services/user.service';
import { NgxToastrService } from '../../../core/services/ngx.toastr.service';

@Component({
  selector: "app-train-confirm-stepper-container",
  templateUrl: "./train-confirm-stepper-container.component.html",
  styleUrls: ["./train-confirm-stepper-container.component.scss"],
})
export class TrainConfirmStepperContainerComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;
  trainsInfo: TrainsInfo;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private trainService: TrainService,
    public translate: TranslateService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private ngxToastrService: NgxToastrService,
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
  }

  ngOnInit(): void {
    this.restoreTrainRedirectStateIfNeeded();
    this.processRedsysReturnIfNeeded();

    if (!this.trainsInfo) {
      this.router.navigate(["/train"]);
    }
  }

  goBack() {
    history.back();
  }

  private restoreTrainRedirectStateIfNeeded(): void {
    if (this.trainsInfo?.selectedTrains && this.trainsInfo?.itineraryId) {
      return;
    }

    const savedStateString = localStorage.getItem('stateTrainRedirect');

    if (!savedStateString) {
      return;
    }

    const savedState = JSON.parse(savedStateString);

    if (savedState.formSearchTrainValue) {
      savedState.formSearchTrain = this.formBuilder.group({
        origin: [savedState.formSearchTrainValue.origin],
        destination: [savedState.formSearchTrainValue.destination],
        departDate: [savedState.formSearchTrainValue.departDate],
        departTime: [savedState.formSearchTrainValue.departTime],
        returnDate: [savedState.formSearchTrainValue.returnDate],
        returnTime: [savedState.formSearchTrainValue.returnTime],
        travellers: [savedState.formSearchTrainValue.travellers],
        selectedProject: [savedState.formSearchTrainValue.selectedProject],
      });
    }

    if (savedState.travellersFormValue) {
      savedState.travellersForm = this.formBuilder.array(
        savedState.travellersFormValue.map((traveller) =>
          this.formBuilder.group({
            name: [traveller.name],
            surname: [traveller.surname],
            lastSurname: [traveller.lastSurname],
            email: [traveller.email],
            birthdate: [traveller.birthdate],
            phone: [traveller.phone],
            documentType: [traveller.documentType],
            documentNumber: [traveller.documentNumber],
            uuid: [traveller.uuid],
            departmentUuid: [traveller.departmentUuid],
          })
        )
      );
    }

    delete savedState.formSearchTrainValue;
    delete savedState.travellersFormValue;

    this.trainService.setTrainsInfoPartial(savedState);
    this.trainsInfo = savedState;
  }

  private processRedsysReturnIfNeeded(): void {
    const params = { ...this.route.snapshot.queryParams };

    const Ds_SignatureVersion = params['Ds_SignatureVersion'];
    const Ds_MerchantParameters = params['Ds_MerchantParameters'];
    const Ds_Signature = params['Ds_Signature'];

    if (!Ds_SignatureVersion || !Ds_MerchantParameters || !Ds_Signature) {
      return;
    }

    const redsysData: any = {
      Ds_SignatureVersion,
      Ds_MerchantParameters,
      Ds_Signature,
    };

    const cardName = localStorage.getItem('cardName');

    if (cardName) {
      redsysData.cardName = cardName;
      localStorage.removeItem('cardName');
    }

    const uuidToBook =
      this.trainsInfo?.userToBook ||
      this.trainsInfo?.userUuid ||
      this.trainsInfo?.user?.uuid;

    if (!uuidToBook) {
      return;
    }

    this.userService.postUserNewTokenRedsys(uuidToBook, redsysData).subscribe(
      (updatedUser) => {
        this.trainService.setTrainsInfoPartial({ user: updatedUser });

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            Ds_SignatureVersion: null,
            Ds_MerchantParameters: null,
            Ds_Signature: null,
          },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });

        this.translate.get("company.card.card-added").subscribe((resp) => {
          this.ngxToastrService.typeSuccess(null, resp);
        });
      },
      () => {
        this.translate.get("company.card.error").subscribe((resp) => {
          this.ngxToastrService.typeInfo(null, resp);
        });
      }
    );
  }
}